/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationCriteria } from './HomeHealthCertificationCriteria';
import {
    HomeHealthCertificationCriteriaFromJSON,
    HomeHealthCertificationCriteriaFromJSONTyped,
    HomeHealthCertificationCriteriaToJSON,
    HomeHealthCertificationCriteriaToJSONTyped,
} from './HomeHealthCertificationCriteria';
import type { HomeHealthCertificationCertification } from './HomeHealthCertificationCertification';
import {
    HomeHealthCertificationCertificationFromJSON,
    HomeHealthCertificationCertificationFromJSONTyped,
    HomeHealthCertificationCertificationToJSON,
    HomeHealthCertificationCertificationToJSONTyped,
} from './HomeHealthCertificationCertification';
import type { HomeHealthCertificationPrimaryReasonForHomeHealth } from './HomeHealthCertificationPrimaryReasonForHomeHealth';
import {
    HomeHealthCertificationPrimaryReasonForHomeHealthFromJSON,
    HomeHealthCertificationPrimaryReasonForHomeHealthFromJSONTyped,
    HomeHealthCertificationPrimaryReasonForHomeHealthToJSON,
    HomeHealthCertificationPrimaryReasonForHomeHealthToJSONTyped,
} from './HomeHealthCertificationPrimaryReasonForHomeHealth';
import type { HomeHealthCertificationReferralOrder } from './HomeHealthCertificationReferralOrder';
import {
    HomeHealthCertificationReferralOrderFromJSON,
    HomeHealthCertificationReferralOrderFromJSONTyped,
    HomeHealthCertificationReferralOrderToJSON,
    HomeHealthCertificationReferralOrderToJSONTyped,
} from './HomeHealthCertificationReferralOrder';

/**
 * 
 * @export
 * @interface HomeHealthCertification
 */
export interface HomeHealthCertification {
    /**
     * 
     * @type {string}
     * @memberof HomeHealthCertification
     */
    schema_version: HomeHealthCertificationSchemaVersionEnum;
    /**
     * 
     * @type {HomeHealthCertificationPrimaryReasonForHomeHealth}
     * @memberof HomeHealthCertification
     */
    primary_reason_for_home_health: HomeHealthCertificationPrimaryReasonForHomeHealth;
    /**
     * 
     * @type {HomeHealthCertificationReferralOrder}
     * @memberof HomeHealthCertification
     */
    referral_order: HomeHealthCertificationReferralOrder;
    /**
     * 
     * @type {HomeHealthCertificationCertification}
     * @memberof HomeHealthCertification
     */
    certification: HomeHealthCertificationCertification;
    /**
     * 
     * @type {HomeHealthCertificationCriteria}
     * @memberof HomeHealthCertification
     */
    criteria: HomeHealthCertificationCriteria;
}


/**
 * @export
 */
export const HomeHealthCertificationSchemaVersionEnum = {
    _10: '1.0'
} as const;
export type HomeHealthCertificationSchemaVersionEnum = typeof HomeHealthCertificationSchemaVersionEnum[keyof typeof HomeHealthCertificationSchemaVersionEnum];


/**
 * Check if a given object implements the HomeHealthCertification interface.
 */
export function instanceOfHomeHealthCertification(value: object): value is HomeHealthCertification {
    if (!('schema_version' in value) || value['schema_version'] === undefined) return false;
    if (!('primary_reason_for_home_health' in value) || value['primary_reason_for_home_health'] === undefined) return false;
    if (!('referral_order' in value) || value['referral_order'] === undefined) return false;
    if (!('certification' in value) || value['certification'] === undefined) return false;
    if (!('criteria' in value) || value['criteria'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationFromJSON(json: any): HomeHealthCertification {
    return HomeHealthCertificationFromJSONTyped(json, false);
}

export function HomeHealthCertificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertification {
    if (json == null) {
        return json;
    }
    return {
        
        'schema_version': json['schema_version'],
        'primary_reason_for_home_health': HomeHealthCertificationPrimaryReasonForHomeHealthFromJSON(json['primary_reason_for_home_health']),
        'referral_order': HomeHealthCertificationReferralOrderFromJSON(json['referral_order']),
        'certification': HomeHealthCertificationCertificationFromJSON(json['certification']),
        'criteria': HomeHealthCertificationCriteriaFromJSON(json['criteria']),
    };
}

export function HomeHealthCertificationToJSON(json: any): HomeHealthCertification {
    return HomeHealthCertificationToJSONTyped(json, false);
}

export function HomeHealthCertificationToJSONTyped(value?: HomeHealthCertification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'schema_version': value['schema_version'],
        'primary_reason_for_home_health': HomeHealthCertificationPrimaryReasonForHomeHealthToJSON(value['primary_reason_for_home_health']),
        'referral_order': HomeHealthCertificationReferralOrderToJSON(value['referral_order']),
        'certification': HomeHealthCertificationCertificationToJSON(value['certification']),
        'criteria': HomeHealthCertificationCriteriaToJSON(value['criteria']),
    };
}

